// extracted by mini-css-extract-plugin
export default {"lineC":"LargeRigthLine_lineC__a0GQA","bottom":"LargeRigthLine_bottom__V3p9a"};